export default "__VITE_ASSET__DzD4xjqK__"